import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginModel } from '../../model/login.model';
import { FormValidationsService, OwnValidators } from 'shared/src/public-api';

@Component({
  selector: 'login-panel',
  templateUrl: './login-panel.component.html',
  styleUrls: ['./login-panel.component.scss'],
})
export class LoginPanelComponent implements OnInit {

  constructor(private formValidationsService: FormValidationsService) { }

  loginForm: FormGroup;
  @ViewChild("mailOrPhone") mailOrPhone: ElementRef;
  @Input() loginBlocked: boolean = false;
  @Input() verificationRequired: boolean = false;
  private _loginModel: LoginModel;
  @Input() set loginModel(model: any) {
    if (JSON.stringify(model) != JSON.stringify(this.loginModel)) {
      this._loginModel = model;
      this.initForm();
      this.loginModelChange.emit(model);
    }
  };
  get loginModel() { return this._loginModel; }

  @Output() mailVerficationClicked: EventEmitter<any> = new EventEmitter();
  @Output() loginModelChange: EventEmitter<LoginModel> = new EventEmitter();
  @Output() submit: EventEmitter<LoginModel> = new EventEmitter();


  ngOnInit(): void {
  }

  initForm() {
    this.loginForm = new FormGroup({
      userMailOrPhone: new FormControl(this._loginModel.userMailOrPhone, [Validators.required, OwnValidators.validateTelOrMail]),
      password: new FormControl(this._loginModel.password, [Validators.required, Validators.maxLength(40), OwnValidators.correctOldPassword])
    });
  }


  onMailVerficationClicked() {
    this.mailVerficationClicked.emit()
  }

  submitForm() {
    if (this.loginForm.valid) {
      this.submit.emit();
    }
    else {
      this.formValidationsService.markFormGroupTouched(this.loginForm);
    }
  }

  setModel() {
    this.loginModel = Object.assign(this.loginModel, this.loginForm.value);
  }

  validMailOrTel() {
    var control = this.loginForm.get("userMailOrPhone");
    if (control.valid) return true;
    else {
      control.markAsDirty();
      control.markAsTouched();
      return false;
    }
  }


}
